import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'prettify' })
export class PrettifyPipe implements PipeTransform {
    transform(value: string,  ...args: any[]): string {
        var op = "";
        if (!value){
            console.log("label undefined");
            return "";
        }
        if (value.indexOf(":") > -1) {
            op = value.split(":")[1];
        } else {
            op = value;
        }

        return op.replace(/_/g, " ");
    }
}